 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE_PAGE from '@/components/Text/title_page'
 import TEXTNAV from '@/components/Text/nav'
 import TEXTCH001 from '@/components/Text/ch001'
 import TEXTCH002 from '@/components/Text/ch002'
 import TEXTCH003 from '@/components/Text/ch003'
 import TEXTCH004 from '@/components/Text/ch004'
 import TEXTCH005 from '@/components/Text/ch005'
 import TEXTCH006 from '@/components/Text/ch006'
 import TEXTCH007 from '@/components/Text/ch007'
 import TEXTCH008 from '@/components/Text/ch008'
 import TEXTCH009 from '@/components/Text/ch009'
 import TEXTCH010 from '@/components/Text/ch010'
 import TEXTCH011 from '@/components/Text/ch011'
 import TEXTCH012 from '@/components/Text/ch012'
 import TEXTCH013 from '@/components/Text/ch013'
 import TEXTCH014 from '@/components/Text/ch014'
 import TEXTCH015 from '@/components/Text/ch015'
 import TEXTCH016 from '@/components/Text/ch016'
 import TEXTCH017 from '@/components/Text/ch017'
 import TEXTCH018 from '@/components/Text/ch018'
 import TEXTCH019 from '@/components/Text/ch019'
 import TEXTCH020 from '@/components/Text/ch020'
 import TEXTCH021 from '@/components/Text/ch021'
 import TEXTCH022 from '@/components/Text/ch022'
 import TEXTCH023 from '@/components/Text/ch023'
 import TEXTCH024 from '@/components/Text/ch024'
 import TEXTCH025 from '@/components/Text/ch025'
 import TEXTCH026 from '@/components/Text/ch026'
 import TEXTCH027 from '@/components/Text/ch027'
 import TEXTCH028 from '@/components/Text/ch028'
 import TEXTCH029 from '@/components/Text/ch029'
 import TEXTCH030 from '@/components/Text/ch030'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/nav",
 			"name" : "Text/nav",
 			"component" : TEXTNAV
 		},
 		{
 			"path" : "/Text/ch001",
 			"name" : "Text/ch001",
 			"component" : TEXTCH001
 		},
 		{
 			"path" : "/Text/ch002",
 			"name" : "Text/ch002",
 			"component" : TEXTCH002
 		},
 		{
 			"path" : "/Text/ch003",
 			"name" : "Text/ch003",
 			"component" : TEXTCH003
 		},
 		{
 			"path" : "/Text/ch004",
 			"name" : "Text/ch004",
 			"component" : TEXTCH004
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js